export enum ProductGroupPublicationOptionEnum {
  EVERY_OWN_DIV = '1',
  SPECIFIED = '2',
  PRIVATE = '3',
}

export const ProductGroupPublicationOption = [
  { label: '自部門の全得意先に公開する', value: ProductGroupPublicationOptionEnum.EVERY_OWN_DIV },
  {
    label: '指定した得意先のみに公開する',
    value: ProductGroupPublicationOptionEnum.SPECIFIED,
  },
  { label: '非公開', value: ProductGroupPublicationOptionEnum.PRIVATE },
];
